import {LeftSideMenu} from "../../components/leftSideMenu/LeftSideMenu";
import {useState} from "react";
import {useNewUsers, useStats} from "../../hooks";
import {BarChart} from "../../components/charts/BarChart";
import Popup from "reactjs-popup";

export function Stats() {
    const [query, setQuery] = useState();
    const {newUsers} = useNewUsers(query);
    const {stats} = useStats(0);
    const options = {
        plugins: {
            legend: {
                labels: {
                    color: '#ffffff'
                }
            },
        },
        scales: {
            x: {
                ticks: {
                    color: "white"
                },
                grid: {
                    color: "white"
                },
                distribution: 'series',
            },
            y: {
                ticks: {
                    beginAtZero: true,
                    color: "white"
                },
                grid: {
                    color: "white"
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        pan: {
            // Boolean to enable panning
            enabled: true,

            // Panning directions. Remove the appropriate direction to disable
            // Eg. 'y' would only allow panning in the y direction
            mode: 'x'
        },
        zoom: {
            enabled: true,
            mode: 'x'
        }
    }

    function handleChange(e) {
        setQuery(e.target.value);
    }

    function GetValues() {

        let newValues = [];
        Object.keys(stats).forEach((key) => {
            if (stats[key]?.docs && stats[key]?.docs.length > 0) {
                newValues.push(stats[key].docs[stats[key].docs.length - 1].rrate * 100);
            }
        })
        return newValues;
    }

    return <LeftSideMenu active="stats">
        <div id="wrapper">
            <div className="container">
                <div className="row">

                    <div className="col-xs-12">
                        <div className="card-box card-tabs m-t-20">
                            <h4 className="header-title pull-right m-t-0 m-b-30">STATISTICS</h4>
                            <ul className="nav nav-pills">

                            </ul>
                            <div className="tab-content">

                                <div id="tabStatsUsers" className="tab-pane fade in active">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-xs-12">
                                                <h4>New Users:
                                                    <Popup position="right center" trigger={<i className="fas fa-info-circle"></i>}
                                                           on={['hover', 'focus']} arrow>
                                                        <div className="popover fade bottom in">
                                                            <h3 className="popover-title">NEW USERS</h3>
                                                            <div className="popover-content">Users registered in a given
                                                                period of time
                                                            </div>
                                                        </div>
                                                    </Popup>
                                                    <span id="totalNewUsers"
                                                          style={{
                                                              marginLeft: "50px",
                                                              color: "#00aced",
                                                              fontSize: "25px"
                                                          }}>0</span>
                                                </h4>
                                            </div>
                                            <div className="col-xs-12">
                                                <form id="formTimeIntervalNewUsers">
                                                    <div className="col-xs-12">
                                                        <div className="input-group col-md-6 pull-right">
                                                            <select id="selectTimeIntervalNewUsers" name="timeInterval"
                                                                    className="form-control custom-select" onChange={handleChange}>
                                                                <option
                                                                    value="1Year">Año
                                                                    en curso
                                                                </option>
                                                                <option
                                                                    value="1week">Última
                                                                    semana
                                                                </option>
                                                                <option
                                                                    value="1month">Último
                                                                    mes
                                                                </option>
                                                                <option
                                                                    value="6months">Últimos
                                                                    6 meses
                                                                </option>
                                                                <option
                                                                    value="https://test.incitytogether.io/stats/getNewUsersCustom">Intevalo
                                                                    Personalizado
                                                                </option>
                                                            </select>
                                                            <span className="input-group-btn">
                                                        <button id="btnSearchNewUsers" type="button"
                                                                className="btn waves-effect waves-light btn-primary"><i
                                                            className="fa fa-search"></i></button>
                                                    </span>
                                                        </div>
                                                    </div>
                                                    <div id="customIntervalNewUsers" className="col-xs-12" hidden>
                                                        <div className="form-group col-xs-12 col-md-6">
                                                            <label>Start Date</label>
                                                            <input name="sDateNewUsers" type="text"
                                                                   className="form-control"/>
                                                        </div>
                                                        <div className="form-group col-xs-12 col-md-6">
                                                            <label>End Date</label>
                                                            <input name="eDateNewUsers" type="text"
                                                                   className="form-control"/>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div className="col-xs-12 col-sm-1"></div>
                                                <div id="chartNewUsers" className="col-xs-12 col-sm-10"></div>
                                                <div className="col-xs-12 col-sm-1"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: "80px"}}>
                                        <div className="col-md-12">
                                            <div className="col-xs-12">
                                                <h4>Active Users:
                                                    <Popup position="right center" trigger={<i className="fas fa-info-circle"></i>}
                                                           on={['hover', 'focus']} arrow>
                                                        <div className="popover fade bottom in">
                                                            <h3 className="popover-title">ACTIVE USERS</h3>
                                                            <div className="popover-content">Users who logged in, at
                                                                least once, in a certain period of time.
                                                            </div>
                                                        </div>
                                                    </Popup>
                                                    <span
                                                        id="totalActiveUsers"
                                                        style={{
                                                            marginLeft: "50px",
                                                            color: "#ffa001",
                                                            fontSize: "25px"
                                                        }}>0</span>
                                                </h4>
                                            </div>
                                            <div className="col-xs-12">
                                                <form id="formTimeIntervalActiveUsers">
                                                    <div className="col-xs-12">
                                                        <div className="input-group col-md-6 pull-right">
                                                            <select id="selectTimeIntervalActiveUsers"
                                                                    name="timeInterval"
                                                                    className="form-control custom-select">
                                                                <option
                                                                    value="https://test.incitytogether.io/stats/getMAU1Year">Año
                                                                    en curso
                                                                </option>
                                                                <option
                                                                    value="https://test.incitytogether.io/stats/getDAU1Week">Última
                                                                    semana
                                                                </option>
                                                                <option
                                                                    value="https://test.incitytogether.io/stats/getDAU1month">Último
                                                                    mes
                                                                </option>
                                                                <option
                                                                    value="https://test.incitytogether.io/stats/getMAU6months">Últimos
                                                                    6 meses
                                                                </option>
                                                                <option
                                                                    value="https://test.incitytogether.io/stats/getActiveUsersCustom">Intevalo
                                                                    Personalizado
                                                                </option>
                                                            </select>
                                                            <span className="input-group-btn">
                                                        <button id="btnSearchActiveUsers" type="button"
                                                                className="btn waves-effect waves-light btn-primary"><i
                                                            className="fa fa-search"></i></button>
                                                    </span>
                                                        </div>
                                                    </div>
                                                    <div id="customIntervalActiveUsers" className="col-xs-12" hidden>
                                                        <div className="form-group col-xs-12 col-md-6">
                                                            <label>Start Date</label>
                                                            <input name="sDateActiveUsers" type="text"
                                                                   className="form-control"/>
                                                        </div>
                                                        <div className="form-group col-xs-12 col-md-6">
                                                            <label>End Date</label>
                                                            <input name="eDateActiveUsers" type="text"
                                                                   className="form-control"/>
                                                        </div>
                                                    </div>
                                                </form>
                                                <div className="col-xs-12 col-sm-1"></div>
                                                <div id="chartActiveUsers" className="col-xs-12 col-sm-10"></div>
                                                <div className="col-xs-12 col-sm-1"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: "80px"}}>
                                        <div className="col-md-12">
                                            <div className="col-xs-12">
                                                <h4>User's retention rate:
                                                    <Popup position="right center" trigger={<i className="fas fa-info-circle"></i>}
                                                           on={['hover', 'focus']} arrow>
                                                        <div className="popover fade bottom in" style={{maxWidth: "800px"}}>
                                                            <h3 className="popover-title">USERS RETENTION RATE</h3>
                                                            <div className="popover-content">The user retention rate is
                                                                the number of users we retain. It is calculated with the
                                                                following formula:
                                                                <br/> <img src='./img/rrate.png'
                                                                           className='img-responsive center-block'
                                                                           alt={"formula"}/></div>
                                                        </div>
                                                    </Popup></h4>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row"
                                         style={{marginTop: "80px", paddingRight: "40px", paddingLeft: "40px"}}>
                                        <BarChart options={options} values={GetValues()} label={'Retention Rate'}
                                                  color={'rgba(0, 172, 237, 1)'}/>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </LeftSideMenu>
}